import React from "react";
import useViewController from "./viewController";
import { useTranslation } from "../../locales";
import BaseAvatar from "../BaseAvatar";
import BaseButton from "../BaseButton";
import BaseIcon from "../BaseIcon";
import "./style.scss";

export default function AppointmentBanner() {
  const { t } = useTranslation();
  const { meetingPartner, show, onClose, onJoinChatClick } = useViewController();

  if (!show) return null;

  return (
    <div className="appointment-banner" data-testid="appointment-banner">
      <div className="appointment-banner__container container">
        <div className="appointment-banner__inner">
          <BaseAvatar className="appointment-banner__avatar mr-3" user={meetingPartner} size={40} />
          <div className="appointment-banner__inner-content">
            <div className="appointment-banner__text fw-normal">
              {t("The appointment with {{screenName}} has already started", {
                screenName: meetingPartner?.screenName || "",
              })}
            </div>
            <BaseButton
              className="appointment-banner__join-btn"
              dataTestId="link-to-chat"
              live
              onClick={onJoinChatClick}
            >
              <BaseIcon className="appointment-banner__join-btn-icon mr-1">camera</BaseIcon>
              {t("Join chat")}
            </BaseButton>
          </div>
          <BaseButton
            className="appointment-banner__close-btn __close-banner"
            dataTestId="appointment-banner-closer"
            icon
            small
            onClick={onClose}
          >
            <BaseIcon>close</BaseIcon>
          </BaseButton>
        </div>
      </div>
    </div>
  );
}
